export default "__VITE_ASSET__DftWE409__"